<template>
  <b-row class="grab">
    <b-col class="col-main-pad">
      <b-row>
        <b-col lg="12" class="col-head-activity">
          <font-awesome-icon icon="draw-polygon" />&nbsp; Configurar Punto a Punto
        </b-col>
        <b-col lg="12">
          <b-form-group>
            <label for="name">Instrucciones de la Actividad</label>
            <b-form-textarea
              v-model="instrucciones"
              placeholder="Ingrese las Instrucciones para Realizar la Actividad"
              rows="2"
              max-rows="3"
            ></b-form-textarea>
          </b-form-group>
        </b-col>
        <b-col lg="12">
          <v-stage ref="stage" :config="stageSize">
            <v-layer ref="layer">
              <v-image :config="configImg" @click="handleClick" />
              <v-circle v-for="(t,index) in pointsSelected" :config="t.configCircle" :key="index" />
            </v-layer>
          </v-stage>
        </b-col>

        <b-col lg="12" style="text-align: right;">
          <button type="button" class="btn btn-primary" @click="openModalGaleria">
            <i class="icon-plus"></i>&nbsp;Seleccionar Recurso
          </button>
        </b-col>
      </b-row>
    </b-col>
    <options-element :index-element="idElement" :index-column="idColumn"></options-element>
    <ModalRecursos
      :id="'modal-manage-galeria-'+idElement"
      :showModal="showModal"
      v-on:closeModal="showModal = $event"
      :typeRecurso="typeRecurso"
      v-on:data-selected="insertImage($event)"
    ></ModalRecursos>
  </b-row>
</template>

<script>

import OptionsElement from "./OptionsElement";
import ModalRecursos from "@/components/ModalRecursos/";

export default {
  name: "Dot",
  components: {
    OptionsElement,
    ModalRecursos
  },
  props: {
    points: {
      type: Array,
      default: () => {
        return new Array();
      }
    },
    desc: { type: String },
    idElement: { type: Number },
    idColumn: { type: Number, default: null },
    recursoSelected: { type: String, default: null }
  },
  data() {
    return {
      stageSize: {
        width: 500,
        height: 0
      },
      //image: null,
      instrucciones: this.desc,
      configImg: {
        image: this.file,
        opacity: 0.3,
        width: 500,
        height: 500
      },
      pointsSelected: this.points,
      file: this.recursoSelected,
      showModal: false,
      typeRecurso: "IMAGEN",
      indexPoint: 0
    };
  },
  created() {
    this.indexPoint = 0;
    let dataMaterial = this.$store.getters["constructor/getActivityData"];
    console.log(dataMaterial);

    setTimeout(() => {
      var elementKonva = document.getElementsByClassName("konvajs-content");
      elementKonva[0].classList.add("main-konva-stage");
      // Verificar si ya existe un recurso seleccionado del material para mostrar en el constructor
      if (dataMaterial.content.length > 0) {
        for (var i = 0; i < dataMaterial.content.length; i++) {
          if (dataMaterial.content[i]["tag"] == "Dot") {
            if (
              dataMaterial.content[i]["file"] != null &&
              dataMaterial.content[i]["file"] != ""
            ) {
              this.loadImageAfterPrev(dataMaterial.content[i]["file"]);
              break;
            }
          }
        }
      }
    }, 500);
  },
  methods: {
    handleClick(event) {
      const mousePos = this.$refs.stage.getNode().getPointerPosition();
      const x = mousePos.x;
      const y = mousePos.y;
      this.addPoint(x, y);
      console.log(this.pointsSelected);
    },
    addPoint(x, y) {
      this.indexPoint++;
      var pointData = {
        configCircle: {
          x: x,
          y: y,
          radius: 3,
          fill: "red",
          strokeWidth: 1
        },
        configTxt: {
          x: x,
          y: y - 18,
          fill: "black",
          fontFamily: "Calibri",
          fontSize: 18,
          text: this.indexPoint
        },
        index: this.indexPoint + 1000
      };
      this.pointsSelected.push(pointData);
    },
    insertImage(e) {
      console.log(e);
      const image = new window.Image();
      image.src = this.$root.setUrlFile(e.file);
      image.onload = () => {
        // set image only when it is loaded
        this.configImg.image = image;
        this.stageSize.height = 500;
      };
      this.file = e.file;
      this.showModal = false;
      this.pointsSelected = [];
    },
    openModalGaleria() {
      this.showModal = true;
    },
    loadImageAfterPrev(file) {
      const image = new window.Image();
      image.src = this.$root.setUrlFile(file);
      image.onload = () => {
        this.configImg.image = image;
        this.stageSize.height = 500;
      };
      this.file = file;
    }
  },
  watch: {
    pointsSelected: {
      handler: function(change) {
        this.$store.dispatch("constructor/updateContentElement", {
          indexElement: this.idElement,
          data: change,
          field: "points",
          indexColumns: this.idColumn
        });
      },
      deep: true
    },
    instrucciones: function(change) {
      this.$store.dispatch("constructor/updateContentElement", {
        indexElement: this.idElement,
        data: change,
        field: "instrucciones",
        indexColumns: this.idColumn
      });
    },
    file: function(change) {
      // se actualiza en el $store el contendio del parrafo con referencia a su posición en el arreglo matriz y   si está posicionado dentro de una columna.
      this.$store.dispatch("constructor/updateContentElement", {
        indexElement: this.idElement,
        data: change,
        field: "file",
        indexColumns: this.idColumn
      });
    }
  }
};
</script>
<style lang="scss">
.main-konva-stage {
  margin: 0 auto !important;
}
canvas{
  cursor: default !important;
}
</style>